import { PURCHASED_CREDITS } from "@/utils/credits";

export const isUnlockAvailable = (userData, profile) => {
  // if (
  //   userData &&
  //   userData.claimedFreeUnlock &&
  //   userData.unlocksLeft &&
  //   userData.unlocksLeft[0]?.isFree &&
  //   !profile.eligible_for_free
  // ) {
  //   return false
  // } else {
  //   return true
  // }

  if (!userData) {
    return false;
  }

  if (profile.eligible_for_free) {
    return true;
  }

  // Has purchased credits
  return (userData.transactions || []).some((t) => t.type === PURCHASED_CREDITS);
};
